// Shim for Node's built-in `url` module — Metro can't resolve it on native.
// @sideway/address only uses `Url.URL || URL`; the global URL is available in RN.
module.exports = { URL: global.URL };
